declare global {
  interface Window {
    googlefc?: {
      showRevocationMessage?: () => void;
      callbackQueue?: Array<Record<string, () => void>>;
    };
    __tcfapi?: (
      command: string,
      version: number,
      callback: (...args: unknown[]) => void,
      parameter?: unknown,
    ) => void;
  }
}

function tryOpenRevocation(): boolean {
  const { googlefc } = window;

  if (typeof googlefc?.showRevocationMessage === 'function') {
    googlefc.showRevocationMessage();
    return true;
  }

  if (googlefc?.callbackQueue) {
    googlefc.callbackQueue.push({
      CONSENT_DATA_READY: () => googlefc.showRevocationMessage?.(),
    });
    return true;
  }

  if (typeof window.__tcfapi === 'function') {
    window.__tcfapi('displayConsentUi', 2, () => {}, null);
    return true;
  }

  return false;
}

/**
 * Rouvre le bandeau Google Privacy & messaging (Funding Choices).
 * Le script CMP est async : on retente brièvement avant d'abandonner,
 * puis on résout false pour que l'appelant affiche un fallback.
 */
export function openGoogleCookiePreferences(): Promise<boolean> {
  if (tryOpenRevocation()) return Promise.resolve(true);

  return new Promise((resolve) => {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (tryOpenRevocation()) {
        window.clearInterval(timer);
        resolve(true);
      } else if (attempts >= 6) {
        window.clearInterval(timer);
        resolve(false);
      }
    }, 250);
  });
}

export function isGaDebugEnabled(): boolean {
  return /(?:^|[?&])ga_debug=1(?:&|$)/.test(window.location.search);
}
